import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, InputNumber, Table, Tooltip } from "antd";
import "./Form.css";
import axios from "axios";
import InputForm from "./InputForm";
import numeral from "numeral";

const { Item: ItemForm } = Form;
const { Column } = Table;

export const OPCOES_COMBO = [
  { key: '1', label: 'Janeiro' },
  { key: '2', label: 'Fevereiro' },
  { key: '3', label: 'Março' },
  { key: '4', label: 'Abril' },
  { key: '5', label: 'Maio' },
  { key: '6', label: 'Junho' },
  { key: '7', label: 'Julho' },
  { key: '8', label: 'Agosto' },
  { key: '9', label: 'Setembro' },
  { key: '10', label: 'Outubro' },
  { key: '11', label: 'Novembro' },
  { key: '12', label: 'Dezembro' },
]


export default class ContratosFatForm extends Component {
  state = {
    listaRegistros: [],
    carregando: false,

    mes: { key: String(new Date().getMonth() + 1), label: '' },
    ano: new Date().getFullYear(),
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.visivel !== propsAnterior.visivel) {
      this.getListaRegistros();
      // this.setState({
      //   // registro: this.props.registroSelecionado,
      // }, () => {
      //   this.getListaRegistros();
      // });
    }
  }

  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true, vlrAberto: 0, vlrPago: 0, vlrTotal: 0, qtdeTit: 0 });
    const { pagina, limite } = this.state;

    axios
      .get('/contratos', {
        params: {
          campoOrdem: 'pes_nome',
          tipoOrdem: 'ASC',
          sitContr: 1,
          bloqueio: 0,
          faturar: 1,
          print: 1,
        }
      })
      .then(response => {
        this.setState({
          listaRegistros: response.data.dados,
          carregando: false,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };



  onOK = () => {
    if (!this.state.mes) {
      Modal.warning({ title: 'Aviso!', content: 'Informe Mês', });
      return;
    }

    if (!this.state.ano) {
      Modal.warning({ title: 'Aviso!', content: 'Informe Ano', });
      return;
    }

    const registro = {
      listaRegistros: this.state.listaRegistros,
      mes: this.state.mes.key,
      ano: this.state.ano,
    };

    // console.log('onOK:', registro)
    // return;

    this.setState({ salvando: true })
    axios.post('/contratos/faturamento', registro)
      .then(response => {
        this.setState({
          formVisivel: false,
          salvando: false,
        })

        this.props.onFatClick();
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        if (error.response.status === 412) {
          Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', },
            this.props.onCancelarFatClick()
          )
        } else {
          Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível gerar. ' + error.response.data, okText: 'OK', },
            this.props.onCancelarFatClick()
          )
        }
      })

  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este cliente do faturamento?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const { listaRegistros, total } = this.state;
        const registroIndex = listaRegistros.findIndex(tar => tar.contr_idf === registro.contr_idf)
        listaRegistros.splice(registroIndex, 1);
        this.setState({
          listaRegistros: listaRegistros.concat([]),
          total: total - 1,
          carregando: false,
        })
      }
    })
  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    this.setState({
      [id]: value
    });
  };

  onInputChangeAno = event => {
    this.setState({ ano: event });
  }


  renderValor = (vlr, registro) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderAcoes = (text, registro) => {
    return (
      <Tooltip title="Excluir">
        <Button type="danger" size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
      </Tooltip>
    );
  };





  render() {
    const { onCancelarFatClick, visivel } = this.props;
    const { listaRegistros, carregando, salvando, mes, ano } = this.state;

    // console.log('ContratosFatForm.this.state: ', this.state);

    return (
      <Modal
        title={"Gerar Faturamento"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarFatClick}
        footer={null}
        width={"40%"}
        style={{ top: 10 }}
      >

        <Row style={{}}>

          <Col xs={24} sm={16} style={{ marginTop: 0, marginBottom: 10 }} className="camposEspacoDireita">
            <span>Mês</span>
            <InputForm
              type="select"
              id="mes"
              ref="mes"
              value={mes}
              placeholder="Selecione o Mês"
              onChange={this.onChange}
              data={OPCOES_COMBO}
              validator={value => Boolean(value)}
              style={{ width: "100%" }}
            />
          </Col>


          <Col xs={24} sm={8} style={{ marginTop: 0, paddingRight: 0, marginBottom: 10 }}>
            <span style={{ fontSize: 13, paddingBottom: 5 }}>Ano</span>
            <div style={{ marginTop: 4 }}>
              <InputNumber
                ref="Input"
                id={ano}
                value={ano}
                onChange={this.onInputChangeAno}
                min={2020}
                max={2100}
                maxLength={6}
                style={{ width: '100%' }}
              />
            </div>
          </Col>


        </Row>

        <div style={{ paddingTop: 0, height: 400 }}>
          <Table
            pagination={false}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            scroll={{ y: 360 }}
            dataSource={listaRegistros}
            rowKey={(registro => registro.contr_idf)}
          >
            <Column
              title="Cliente"
              key="pes_nome"
              dataIndex="pes_nome"
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={350}
              align="left"
              className="listaCadastro"
            />
            <Column
              title="Valor"
              key="contr_valor_mensal"
              dataIndex="contr_valor_mensal"
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderValor}
              width={90}
              align="right"
              className="listaCadastro"
            />
            <Column
              title="."
              key="acoes"
              // title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
              render={this.renderAcoes}
              width={90}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={this.onOK}
                  className="btn-salvar"
                  style={{ width: 130 }}
                  loading={salvando}
                >
                  Faturar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarFatClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>


      </Modal >



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContratosFatForm.js